import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'antd';

import { uploadFlatsGridByFile } from '../../../../../../requests/flatsGridByFile';
import { getQueryKeys } from '../../../../../../queries/queryKeys';
import { texts } from '../../../../../../constants/texts';
import { selectGridPreview, selectHasGridData } from '../../../../lib/storeSelectors';
import { resetFlatsGridPreviewData } from '../../../../../../store/actions/housingStockActions';
import { useModalActions } from '../../providers/modals';

const { confirm } = Modal;

export const FlatsGridPreviewActions = () => {
  const { houseId, file } = useSelector(selectGridPreview);
  const hasFlatsGrid = useSelector(selectHasGridData);
  const hasPreviewData = Boolean(file);

  const dispatch = useDispatch();
  const resetPreviewData = () => dispatch(resetFlatsGridPreviewData());

  const {
    showFlatsGridModal: showModal,
    hideFlatsGridModal: hideModal,
    showFlatsGridUploading: showUploading,
    hideFlatsGridUploading: hideUploading,
  } = useModalActions();

  const queryClient = useQueryClient();

  const uploadFlatsGridMutation = useMutation(
    (values) => uploadFlatsGridByFile(values),
    {
      onMutate: () => {
        showUploading();
      },
      onSuccess: () => {
        hideUploading();
        resetPreviewData();
        hideModal();
        queryClient.invalidateQueries(getQueryKeys.flatsGrid(houseId));
      },
      onError: () => {
        hideUploading();
      },
    }
  );

  const handlePreviewSave = () => {
    confirm({
      title: `Выйти из режима предварительного просмотра?
        (Проверьте номера помещений, если они не совпадают с имеющимися будут созданы новые)`,
      okText: texts.yes,
      cancelText: texts.no,
      onOk: () => {
        uploadFlatsGridMutation.mutate({
          houseId,
          file: file,
        });
      },
      onCancel: () => {},
    });
  };

  const cancelTitle = hasFlatsGrid
    ? texts.flatsGridPreviewCancelEditConfiramtion
    : texts.flatsGridPreviewCancelCreateConfiramtion;
  const handlePreviewCancel = () => {
    confirm({
      title: cancelTitle,
      okText: texts.yes,
      cancelText: texts.no,
      onOk: () => {
        resetPreviewData();
        hideModal();
      },
      onCancel: () => {},
    });
  };

  const handlePreviewReload = () => {
    showModal();
  };

  return (
    <div>
      {!hasPreviewData && hasFlatsGrid && (
        <Button
          type="link"
          onClick={showModal}
        >
          Редактировать
        </Button>
      )}
      {hasPreviewData && (
        <>
          <Button
            type="link"
            onClick={handlePreviewReload}
            disabled={uploadFlatsGridMutation.isLoading}
          >
            Загрузить заново
          </Button>
          <Button
            type="link"
            onClick={handlePreviewCancel}
            disabled={uploadFlatsGridMutation.isLoading}
          >
            Отмена
          </Button>
          <Button
            type="link"
            onClick={handlePreviewSave}
            loading={uploadFlatsGridMutation.isLoading}
          >
            Сохранить и выйти из режима
          </Button>
        </>
      )}
    </div>
  );
};
